import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function RingDownSpeedRow() {
   return (
      <InputRangeRow
         titleProp={"Ring Down Speed"}
         descriptionProp={"mm/s"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={5}
         maxProp={99.9} //some default value
         propertyNameProp={"ringSpeedDown"}
         errorDialogueProp={"5.0-99.9"}
         floatProp={true}
      />
   );
}
